import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Translator } from '@vectronic/util';

@Component({
  selector: 'table-datatable-users-count',
  templateUrl: './datatable-users-count.component.html',
  styleUrls: ['./datatable-users-count.component.scss'],
  imports: [CommonModule, OverlayModule, MatCardModule],
})
export class DatatableUsersCountComponent {
  row = input<any>();
  isOpen = signal(false);
  Translator = Translator;

  shares = computed(() => this.row()?.shares);

  onMouseOver() {
    this.isOpen.set(true);
  }

  onMouseOut() {
    this.isOpen.set(false);
  }
}
